export const m = {

  // common
  submit: '提交',
  save: '保存',
  updatedSuccess: '修改成功',
  saveSuccess: '保存成功',
  cancel: '取消',
  confirm: '确定',
  close: '关闭',
  add: '添加',
  clear: '清空',
  required: '必填',
  logout: '退出登录',
  unit: '单位',
  comfirmQuit: '确定退出？',
  noRecord: '没有记录 ~',
  aboutus: '关于我们',
  contactus: '联系我们',
  aboutPortdistance: '关于PortDistance',
  aboutMarineCircle: '关于海运圈',
  shopping: '价格与购买',
  purchaseInfo: '购买情况',

  login: '登录',
  email: '邮箱地址',
  password: '密码',
  forgetPassword: '忘记密码？',
  createAccount: '创建账号',
  signin: '登录',
  errorLogin: '用户名或密码错误！',
  signup: '注册',
  nickname: '用户昵称',
  company: '公司名称',
  hasAccount: '已有账号？立即登录',
  passwordMinLength: '密码不少于6位',
  emailInvalid: 'E-mail格式不正确',
  nicknameInvalid: '用户昵称格式不正确',
  companyInvalid: '公司名称格式不正确',
  nicknameHint: '4到16位(字母，数字，下划线，减号)',
  companyHint: '不少于4位',
  emailBeUsed: '邮箱地址已被注册',
  nicknameBeUsed: '该昵称已被占用',
  signupSuccess: '注册成功，请登录',

  enterRegisteredEmail: '请输入注册邮箱',
  notExistedEmail: '该邮箱地址未注册',
  checkMailBox: '请检查您的邮箱！',
  resetLinkSent: '密码重置链接已发送，请查收。',

  // 设置 与 左菜单
  distance: '航程计算',
  estimation: '航次预算',
  vessel: '船舶规范',
  setting: '设置',

  personalProfile: '个人信息',
  personalInfo: '个人基本信息',
  realName: '真实姓名',
  mobile: '手机',
  gender: '性别',
  pleaseChoose: '请选择',
  male: '男',
  female: '女',
  companyInformation: '公司基本信息',
  title: '职务',
  department: '部门',
  nation: '国家',
  tel: '电话',
  city: '城市',
  address: '公司地址',
  aboutMe: '关于我',

  changePasswd: '密码修改',
  oldPasswd: '旧密码',
  newPasswd: '新密码',
  crrntPsswrdIncrrct: '当前密码不正确',
  updatedPassword: '密码修改成功',
  changeAccount: '修改账户',
  changeAccount2: '修改账户邮箱',
  accountEmailHint: '修改后登陆新邮箱点击确认链接，新账户方可生效。',
  newEmailAddress: '新邮箱地址',
  checkExistedEmail: '该邮箱地址已被注册！',

  language: '语言',
  marinecircle: '上海莫瑞斯柯信息技术有限公司',

  // 航程计算 与 航次预算
  nm: '海里',
  port: '港口',
  distance: '航程距离',
  seaDays: '航行',
  idleDays: '待港',
  workDays: '作业',
  seaDaysShort: '航行',
  idleDaysShort: '待港',
  workDaysShort: '作业',
  days: '天',
  ttlDistance: '全部航程',
  ttlEcaDistance: 'ECA航程',
  ttlTime: '航行时间',
  getDistance: '获取航程',

  // 航程计算
  moreDisInfo: '查看更多',
  clearOnlyDis: '清除航程',
  clearDisAll: '清除所有',
  enterPort: '输入港口 (至少两个关键字)',
  asl: '印尼群岛水道(ASL)',
  antiPiracy: '避开海盗绕航',
  pointOptionExc: '不允许经过',
  pointOptionDefault: '允许经过',
  pointOptionRequired: '必须经过',

  routingPointStatus: '路由点状态',
  plsGetDistance: '请先完成航程计算',
  wayPointExists: '该路由点已添加',
  thePortExists: '该港口已经存在',
  gettedDistanceFail: '计算发生错误，不存在该路由点',

  turningConfig: '转向点设置',
  turningPointsEdit: '坐标位置编辑',
  lonLatDecimal: '数值',
  dms: '度分秒',
  dm: '度分',
  lonAbbrev: '经度',
  latAbbrev: '纬度',
  addWayPoint: '增加转向点',
  updateWayPoint: '修改转向点',
  delWayPoint: '删除转向点',
  enterValidLonLat: '输入有效经纬度！',
  enterCoordinate: '输入坐标',

  // 航次预算
  comfirmDelEsti: '确定删除该预算？',
  editEsti: '编辑航次预算',
  addEsti: '新增航次预算',
  cargoInfo: '货物信息',
  cargo: '货物',
  portRotation: '港口序列',
  particularAndFuel: '船舶规范与油耗',
  costAndResult: '成本与预算结果',
  cost: '成本',
  enterEstiName: '输入预算名称',
  estiName: '预算名称',
  estiNameRequired: '预算名称不能为空',
  littleCargoInfo: '货物信息太少！',
  noGeneratePortList: '没有生成港序！',
  inputCargoAndPort: '请填写货种与装卸港',
  cargoType: '货种',
  cargoQuantity: '货量',
  fee: '运费',
  income: '收入',
  lPort: '装货港',
  dPort: '卸货港',
  addCommRate: '回扣佣金',
  brokerageRate: '经纪佣金',
  frtTaxRate: '其他税费',
  ttlVoyDays: '航次总时间(天)',
  ttlSeaDays: '航行',
  ttlPortIdleDays: '待港',
  ttlPortWorkDays: '作业',
  openMap: '打开地图',
  clearPortSeq: '清除港序',
  genPortSeq: '生成港序',
  taskTypeName: '任务',
  portCharge: '港口使费',
  arrivedDate: '到港日期',
  arrivedTime: '到港时间',
  departed: '离港时间',
  margin: '余量',
  addPort: '添加港口',
  getDis: '获取航程',
  clearDis: '清除航程',
  addPortTo: '添加至',
  addPortPosition: '位置',
  portPosTop: '上方',
  portPosBottom: '下方',
  clearSeqConfirm: '已经获得航程，确定清除港序？',
  clearDisConfirm: '确定清除航程？',
  inputCargoAndLD: '请填写货种与装卸港',
  selectVessel: '选择船舶',
  selectArrivedDate: '请选择到港日期',
  datePicker: '选择到港日期',
  vesselForEsti: '船舶',
  speedFull: '全速',
  speedEco: '经济',
  speedBallast: '空载航速',
  speedLaden: '装载航速',
  foConsump: '燃料油(吨/天)',
  doConsumpForEsti: '柴油(吨/天)',
  consumption: '消耗',
  price: '价格',
  cost: '费用',

  hirePerDay: '日租金',
  hire: '租金',
  hireCommPercent: '租金佣金',
  demurrage: '滞期费',
  dispatch: '速遣费',
  ilohc: '扫舱费',
  ballastBonus: '空放补贴',
  opOther: '其他费用',
  cev: '通讯娱乐伙食补贴',
  fuelCost: '燃油费',
  opCost: '航次成本',
  estiResult: '预算结果',
  asHirePerDay: '日租金水平',
  opProfit: '航次利润',
  ttlRevenue: '航次收入',
  ttlExpense: '总成本',
  netProfit: '净利润',

  taskBallast: '空载',
  taskLoading: '装货',
  taskDischarging: '卸货',
  taskBunker: '加油',
  taskCanal: '过运河',
  taskPassing: '过闸',
  taskRouting: '路由点',

  // 船舶规范
  deleteVessel: '确定删除该船舶规范？',
  completeBaseVessel: '请完整填写基本规范！',
  ton: '吨',
  meter: '米',
  speed: '航速',
  knots: '节',
  cbm: '立方米',
  tonPerDay: 'MT/Day',

  vesselParticulars: '船舶规范',
  editParticular: '编辑船舶规范',
  addParticular: '新增船舶规范',
  vesselBase: '基本规范',
  shipName: '船名',
  inputShipName: '请输入船名',
  vesselExists: '该船名已存在',
  vesselType: '船舶类型',
  dwt: '载重吨',
  inputDwt: '请输入载重吨',
  dwtIsNumber: '请输入数字值',
  flag: '船旗',
  chooseVesselFlag: '请选择船旗',
  builtYear: '建造年代',
  inputBuiltYear: '请输入建造年代',
  draft: '吃水',
  inputDraft: '请输入吃水',
  draftIsNumber: '请输入数字值',
  dwcc: '载货吨',
  grt: '总吨',
  nrt: '净吨',
  loa: '船长',
  inputLoa: '请输入船长',
  loaIsNumber: '请输入数字值',
  beam: '船宽',
  depth: '型深',
  holdHatch: '货舱规范',
  gbCapticity: 'Grain / Bale Capacity',
  holdHatchDeck: 'Hold / Hatch / Deck Number',
  hatchType: '舱盖类型',
  hatchSize: '舱口尺寸',
  holdSize: '货舱尺寸',
  gearDesc: '起重设备',
  otherDetail: '其他规范',
  iMOCode: 'IMO编号',
  callSign: '呼号',
  pAndI: '互保协会',
  class: '船级社',
  ss: '特检日期',
  ssDate: ' 选择下次特检日期',
  dd: '坞检日期',
  ddDate: '选择下次坞检日期',
  mainEngine: '主机',
  shipyard: '建造船厂',
  speedFuel: '航速及油耗',
  fuelType: '油料品种',
  atSea: '航行',
  atPort: '在港',
  foDoConsump: '燃料油消耗(吨/天)',
  lsFoLSDoConsump: '低硫油消耗(吨/天)',
  doAtSea: '航行时柴油消耗',
  fuelConsumpUnit: '吨/天',
  atPortIdle: '在港(空闲)',
  atPortWork: '在港(作业)',
  fo: '燃料油',
  do: '柴油',
  lsfo: 'ECA燃料油',
  lsdo: 'ECA柴油',
  ecoSpeed: '经济航速',
  seaBallast: '航行(空载)',
  seaLaden: '航行(装载)',
  fullSpeed: '全速航速',
  seaDoConsumption: '航行时柴油消耗',
  grainCapacity: '散装舱容',
  baleCapacity: '袋装舱容',
  holdNum: '舱口数',
  hatchNum: '舱盖数',
  deckNum: '甲板数'
}
